var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduleTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5008 7.99551C8.43474 7.99551 5.94922 10.481 5.94922 13.5471V22.6049C5.94922 25.6709 8.43474 28.1564 11.5008 28.1564H18.075M15.4453 7.99551H17.0523H19.8281H22.6039C25.6699 7.99551 28.1555 10.481 28.1555 13.5471V18.076M12.6695 10.0408V5.9502M21.4352 10.0408V5.9502M6.53359 16.1768H28.0094M24.0648 24.2119L25.3797 22.8971",
    stroke: "#8A94A6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0652 28.1563C26.3244 28.1563 28.1559 26.3249 28.1559 24.0657C28.1559 21.8065 26.3244 19.9751 24.0652 19.9751C21.806 19.9751 19.9746 21.8065 19.9746 24.0657C19.9746 26.3249 21.806 28.1563 24.0652 28.1563Z",
    stroke: "#8A94A6",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTime);
export default __webpack_public_path__ + "static/media/schedule-time.7d774fce633fc8aeed536fe0aeace5f5.svg";
export { ForwardRef as ReactComponent };